import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles, children }) => {
  const token = localStorage.getItem('@h2tms/token');
  const role = localStorage.getItem('@h2tms/role');

  if (token === null || role === null) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles !== undefined && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
